import React from 'react';

import style from './index.scss';

const HeaderPanel = ({ title, data, footerData }) => {
  const panelBodyFields = data.map((dataItem, dataItemIndex) => {
    if (dataItem) {
      return (
        <div key={dataItemIndex} className={style.panelFieldSet}>
          <div className="row">
            <div className="col-sm-6">
              <span className={style.fieldLabel}>
                {dataItem.fieldLabel || '-'}
              </span>
            </div>
            <div className="col-sm-6">
              <span className={style.fieldValue}>
                {dataItem.fieldValue || '-'}
              </span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  });

  const panelFooterFields = footerData.map((dataItem, dataItemIndex) => {
    if (dataItem) {
      return (
        <div key={dataItemIndex} className={style.panelFieldSet}>
          <div className="row">
            <div className="col-sm-6">
              <span className={style.fieldLabel}>
                {dataItem.fieldLabel || '-'}
              </span>
            </div>
            <div className="col-sm-6">
              <span className={style.fieldValue}>
                {dataItem.fieldValue || '-'}
              </span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  });

  return (
    <div className={style.mainPanelContainer}>
      <div className={style.panelBody}>
        <p className={style.headerTitle}>{title}</p>
        {panelBodyFields}
      </div>
      <div className={style.panelFooter}>{panelFooterFields}</div>
    </div>
  );
};

export default HeaderPanel;
